let cryptoModule;
if (process.env.NODE_ENV === "production") {
  cryptoModule = require("./crypo.obf.js");
} else {
  cryptoModule = require("./crypo.js");
}
module.exports = cryptoModule;
